/* eslint-disable react/jsx-key */
import React from "react";
import ExternalButton from "@stadium/ui/src/components/button/external-button";

import defaultStyles from "@stadium/ui/src/components/ProfileDropdown/main.module.scss";

const defaultFn = () => {};

const renderProfileLink = ({ to, linkClassName, label, onLinkClick = null }) => {
  return (
    <ExternalButton
      btnStyle="no-style"
      className={linkClassName}
      href={to}
      target="_blank"
      onClick={onLinkClick}
    >
      {label}
    </ExternalButton>
  );
};

const ProfileList = ({
  items = [],
  title,
  styles = defaultStyles,
  className = "",
  renderLink = renderProfileLink,
}) => {
  return (
    <div
      className={`${styles.userDropdownMenuCol} ${className} ${styles.userDropdownMenuColLeftNav}`}
    >
      <div className={styles.userDropdownMenuTitle}>{title}</div>
      {items.map((link) => {
        const {
          to,
          label,
          linkClassName = styles.userDropdownMenuLink,
          isActive,
          onLinkClick = null,
          renderPillTag = defaultFn,
          otherProps = {},
        } = link;
        return (
          <div className={styles.userDropdownMenuLinkContainer} key={to}>
            {renderLink({
              to,
              label,
              linkClassName,
              isActive,
              onLinkClick,
              renderPillTag,
              otherProps,
            })}
          </div>
        );
      })}
    </div>
  );
};

export default ProfileList;
